import config from '../configs/config.js';
import VNode from 'virtual-dom/vnode/vnode';
import VText from 'virtual-dom/vnode/vtext';
import createElement from 'virtual-dom/create-element';
import htmlToVdom from 'html-to-vdom';

let convertHTML = htmlToVdom({
    VNode: VNode,
    VText: VText
});
//import gm from 'googlemaps';

class GoogleGeocode {
	constructor() {
		// Nothing to pass here
	}

    /**
     * Geocode a string into an address and return coorinates
     * @param  {string} String from input
     * @return {object}  lat & long coordinates
     */
	findAddress(string) {
        return new Promise (function(resolve, reject){
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: string }, function(results, status) {
                if (status !== google.maps.GeocoderStatus.OK) {
                    if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                        return reject(Error('no stores'));
                    }

                    return reject(Error('Geocode was unsuccessful: ' + status));
                }
                let firstResult = {};
                firstResult.lat = results[0].geometry.location.lat();
                firstResult.lng = results[0].geometry.location.lng();
                return resolve(firstResult);

            }.bind(this));
        });
    }

    /**
     * build a map for search results
     * @param  {object} address
     * @return {object} passed through, not modified
     */
    buildMap(address){
        if(config.defaults.useMockData){
            return new Promise(function(resolve,reject){
                resolve(address);
            });
        }
        else{
            return new Promise(function(resolve, reject){

                let latlng = new google.maps.LatLng(address.lat, address.lng),
                myOptions = {
                    scrollwheel: false,
                    panControl: false,
                    draggable: false,
                    navigationControl: false,
                    zoom: 8,
                    center: latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };
                let mapElement = createElement(convertHTML('<div id="map_canvas" style="width: 100%; height: 150px"></div>'));
                let map = new google.maps.Map(mapElement, myOptions);
                //console.log(mapElement);
                //jQuery('#map_container').html(mapElement);
                resolve({mapElement: mapElement, map: map});
            })
        }
    }

}

/**
	* Http Request
	* @param {Object} options
	*/

let service = new GoogleGeocode();

export default service;
